module.exports = __webpack_public_path__ + "img/9788954432085.36fd3a1e.jpg";